import { WarningAmberOutlined } from "@mui/icons-material";
import { useTranslations } from "adapters/i18n";
import Auth from "features/authentication/Auth";
import ConfirmationModal from "features/shared/components/confirmationModal";
import React from "react";

const ModalLockClient = ({ classes }) => {
  const { t } = useTranslations();

  return (
    <ConfirmationModal
      classNames={{
        submitButtonClass: classes.submitButtonClass,
        customClass: classes.customClass,
        submitButtonContainer: classes.submitButtonContainer,
        customTitleClass: classes.modalTitleLeft,
      }}
      title={
        <span
          className={classes.modalTitle}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 24,
          }}
        >
          <WarningAmberOutlined />
          {t("common:status.attention")}
        </span>
      }
      text={
        <span className={classes.modalText}>
          {t("errors:lock-client-access")}
        </span>
      }
      submitButtonTitle={t("common:actions.close")}
      onSubmit={Auth.logout}
      onClose={Auth.logout}
    />
  );
};

export default ModalLockClient;
